import {View} from "@lernetz/ts-lib";
import {languageService} from "../services/lang";
import template from "./Missing.html"

export class MissingPageView extends View {
    constructor() {
        super({template})
    }
}

export class MissingPageController {
    currentLang: any;
    init() {
        this.currentLang = languageService.currentLang;
    }
}
